<section class="section focus-on-success">
  <div class="shapes-container">
    <div class="shape shape-triangle" data-aos="flip-left">
      <div></div>
    </div>
    <div class="shape shape-ring shape-ring-2"></div>
  </div>

  <div class="container bring-to-front">
    <div class="row gap-y align-items-center">
      <div class="col-md-6">
        <div class="iphone-x shadow-lg ml-md-0">
          <div class="screen shadow-box">
            <img src="assets/img/screens/app/4.png" alt="..." />
          </div>
          <div class="notch"></div>
        </div>
      </div>

      <div class="col-md-6 text-center text-md-left">
        <div class="section-heading">
          <h2 class="light font-md display-md-4 heading-line">
            Focus on your success, not UI
          </h2>
          <p class="lead text-muted">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Labore
            sapiente facere minus voluptas, dolorem officia dolores odit natus
            at tempore
          </p>
        </div>

        <p>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint culpa
          enim rem ex in quos magnam itaque deleniti, molestiae accusantium sed
          nobis illum quisquam minus aliquid id sapiente nemo excepturi?
        </p>
      </div>
    </div>
  </div>
</section>
